import "./MainCard.css";
import DropdownMenu from "../DropdownMenu/DropdownMenu.jsx";
import { useState, useEffect } from "react";
import Card from "../Card/Card.jsx";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteFilter,
  getFilter,
  getProduct,
  priceFilter,
} from "../../redux/actions";
import Carrito from "../Carrito/Carrito";
import jwt from "jsonwebtoken";
import useLocalStorage from "../../utils/useLocalStorage/useLocalStorage.js";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import CardMobile from "../CardMobile/CardMobile.jsx";
import FilterMobile from "../FilterMobile/FilterMobile.jsx";
import filterImg from "../../assets/icon-filtros-sce.svg";
import CardPromo from "../CardPromo/Card.jsx";
import CardPromoMobile from "../CardPromoMobile/CardMobile.jsx";
import { trackEvent } from "../../utils/fbpPixel.js";

const JWT_SECRET = "tu_clave_secreta";

export default function MainCard({ opciones, category, buscador, promo }) {
  const token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(true);
  const [displayedCards, setDisplayedCards] = useState([]);
  const [filter, setFilter] = useState("");
  const [sendOptions, setSendOptions] = useState([]);
  const [filterOrder, setFilterOrder] = useState("Mayor precio");
  const [order, setOrder] = useState([
    "Mayor precio",
    "Menor precio",
    "A-Z",
    "Z-A",
  ]);
  const [opcionesModelo, setOpcionesModelo] = useState([
    "Todos",
    "Importado",
    "Nacional",
  ]);
  const [limit, setLimit] = useState(8);
  const [tipoFilter, setTipoFilter] = useState("Mayor precio");
  const [admin, setAdmin] = useState(false);
  const [carrito, setCarrito] = useState(false);
  const dispatch = useDispatch();
  const [openOne, setOpenOne] = useState(false);
  const [isOpenMobileFilter, setIsOpenMobileFilter] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const { tipoDeProducto } = useParams();
  const cards = useSelector((state) => state.allPriceFilter);
  const precioDolar = useSelector((state) => state.dolarPrice);
  const [showMenorPrecio, setShowMenorPrecio] = useState(false);
  const [showMayorPrecio, setShowMayorPrecio] = useState(false);
  const [cart, setCart] = useLocalStorage("cart", []);
  const dolar = useSelector((state) => state.dolarPrice);
  const addToCart = (item) => {
    setCart([...cart, item]);
  };
  const [filtrosPrecios, setFiltrosPrecios] = useState({
    mayorPrecio: 5000000000,
    menorPrecio: 0,
    dolar: precioDolar || 1210,
  });

  useEffect(() => {
    dispatch(getProduct([tipoDeProducto], undefined, category, setIsLoading));
    if (tipoDeProducto) {
      const tipo =
        tipoDeProducto.charAt(0).toUpperCase() +
        tipoDeProducto.slice(1).toLowerCase();
      const productoTipo = tipo.split("-").join(" ");
      dispatch(getFilter(productoTipo));
    }
  }, [tipoDeProducto]);

  const filtrosActivos = useSelector((state) => state.allFilter);

  useEffect(() => {
    // Enviar el evento ViewContent con parámetros adicionales
    trackEvent('ViewContent', {
        content_type: 'category',
        content_name: category,
        currency: 'ARS',
    });
  }, [category]);

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwt.verify(token, JWT_SECRET);
        setAdmin(decodedToken.permisos);
      } catch (error) {
        console.error("Token no válido o caducado:", error.message);
      }
    }

    let timer;

    if (cards.length !== 0) {
      if (buscador) {
        setDisplayedCards(buscador);
        setIsLoading(false);
      } else {
        setDisplayedCards(cards);
        setIsLoading(false);
      }
    } else if (buscador) {
      setDisplayedCards(buscador);
      setIsLoading(false);
    } else {
      timer = setTimeout(() => {
        setIsLoading(false);
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [cards, limit, dispatch]);

  const handleDelete = (opcion) => {
    dispatch(deleteFilter(opcion));
    setSendOptions(sendOptions.filter((option) => option !== opcion));
    dispatch(
      getProduct(
        [...sendOptions.filter((option) => option !== opcion)],
        undefined,
        category,
        setIsLoading
      )
    );
  };

  return (
    <>
      <div className="lg:mx-10 mx-3 2xl:pl-[14%] 2xl:pr-[12%]">
        <div className="flex flex-col">
          <div className="flex justify-between text-sm">
            <div className="lg:flex hidden flex-row mt-4 font-medium">
              <div className="flex flex-row">
                <div className="mt-1 ml-2">
                  <DropdownMenu
                    price={true}
                    setShowMenorPrecio={setShowMenorPrecio}
                    setIsOpenOne={setOpenOne}
                    openOne={openOne}
                    setShowMayorPrecio={setShowMayorPrecio}
                    title={"Precio"}
                    category={category}
                    selectedOptions={selectedOptions}
                    filtrosPrecios={filtrosPrecios}
                    setFiltrosPrecios={setFiltrosPrecios}
                    setSelectedOptions={setSelectedOptions}
                    request={true}
                    setIsLoading={setIsLoading}
                    sendOptions={sendOptions}
                    setSendOptions={setSendOptions}
                  />
                </div>
              </div>
              <div className="flex flex-row mx-5">
                <div className="mt-1 ml-2">
                  <DropdownMenu
                    opcionSelect={setFilter}
                    setIsOpenOne={setOpenOne}
                    openOne={openOne}
                    title={"Tipo de Producto"}
                    isShop={category == "shop"}
                    opciones={opciones}
                    filtrosPrecios={filtrosPrecios}
                    setFiltrosPrecios={setFiltrosPrecios}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    category={category}
                    setIsLoading={setIsLoading}
                    sendOptions={sendOptions}
                    setSendOptions={setSendOptions}
                  />
                </div>
              </div>
              <div className="flex flex-row mr-5">
                <div className="mt-1 ml-2">
                  <DropdownMenu
                    opcionSelect={setFilter}
                    isOrigin={true}
                    setIsOpenOne={setOpenOne}
                    openOne={openOne}
                    title={"Modelo"}
                    category={category}
                    filtrosPrecios={filtrosPrecios}
                    setFiltrosPrecios={setFiltrosPrecios}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    opciones={opcionesModelo}
                    setIsLoading={setIsLoading}
                    sendOptions={sendOptions}
                    setSendOptions={setSendOptions}
                  />
                </div>
              </div>
            </div>
            <div className="lg:hidden">
              <button
                onClick={() => setIsOpenMobileFilter(!isOpenMobileFilter)}
              >
                <div className="w-12 border-black rounded-sm">
                  <FilterMobile
                    opcionSelect={setFilter}
                    isOpen={isOpenMobileFilter}
                    setIsOpenOne={setOpenOne}
                    openOne={openOne}
                    setIsOpen={setIsOpenMobileFilter}
                    opciones={opciones}
                    filtrosPrecios={filtrosPrecios}
                    setFiltrosPrecios={setFiltrosPrecios}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    category={category}
                    setIsLoading={setIsLoading}
                    sendOptions={sendOptions}
                    setSendOptions={setSendOptions}
                  />
                </div>
              </button>
            </div>
            <div className="font-medium flex flex-col items-end text-sm">
              <span className="mb-1 opacity-90">Ordenar por</span>
              <div className="flex flex-row">
                <span className="mt-1 g:ml-2">
                  <DropdownMenu
                    opcionSelect={setFilterOrder}
                    title={tipoFilter}
                    setIsOpenOne={setOpenOne}
                    openOne={openOne}
                    tipoFilter={tipoFilter}
                    setTipoFilter={setTipoFilter}
                    tipo={true}
                    category={category}
                    filtrosPrecios={filtrosPrecios}
                    setFiltrosPrecios={setFiltrosPrecios}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    opciones={order}
                    setIsLoading={setIsLoading}
                    sendOptions={sendOptions}
                    setSendOptions={setSendOptions}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="border-t-[0.5px] border-black mt-4"></div>
          <div className="flex text-[13px] justify-start opacity-75 mt-3">
            <span>Filtros aplicados:</span>
            {filtrosActivos &&
              filtrosActivos.map((filtro) => (
                <div>
                  <div className="ml-3 bg-gray-200 px-2">
                    <span>{filtro}</span>
                    <button
                      onClick={() => {
                        handleDelete(filtro);
                      }}
                      className="ml-2"
                    >
                      x
                    </button>
                  </div>
                </div>
              ))}
            {showMayorPrecio && (
              <div>
                <div className="ml-3 bg-gray-200 px-2">
                  <span>
                    Precio hasta:{" "}
                    {Number(filtrosPrecios.mayorPrecio).toLocaleString(
                      "es-AR",
                      {
                        style: "currency",
                        currency: "ARS",
                        maximumFractionDigits: 0,
                      }
                    )}
                  </span>
                  <button
                    onClick={() => {
                      dispatch(
                        priceFilter({
                          ...filtrosPrecios,
                          mayorPrecio: 5000000000,
                          dolar: precioDolar,
                        })
                      );
                      setFiltrosPrecios({
                        ...filtrosPrecios,
                        mayorPrecio: 5000000000,
                        dolar: precioDolar,
                      });
                      setShowMayorPrecio(false);
                    }}
                    className="ml-2"
                  >
                    x
                  </button>
                </div>
              </div>
            )}
            {showMenorPrecio && (
              <div>
                <div className="ml-3 bg-gray-200 px-2">
                  <span>
                    Precio desde:{" "}
                    {Number(filtrosPrecios.menorPrecio).toLocaleString(
                      "es-AR",
                      {
                        style: "currency",
                        currency: "ARS",
                        maximumFractionDigits: 0,
                      }
                    )}
                  </span>
                  <button
                    onClick={() => {
                      setShowMenorPrecio(false);
                      dispatch(
                        priceFilter({
                          ...filtrosPrecios,
                          menorPrecio: 0,
                          dolar: precioDolar,
                        })
                      );
                      setFiltrosPrecios({
                        ...filtrosPrecios,
                        menorPrecio: 0,
                        dolar: precioDolar,
                      });
                    }}
                    className="ml-2"
                  >
                    x
                  </button>
                </div>
              </div>
            )}
            {filtrosActivos.length > 0 && (
              <button className="text-sm ml-3">
                <span
                  onClick={() => {
                    window.location.href = "/shop";
                  }}
                  className="mr-2 hover:border-black border-b-2 border-gray-400"
                >
                  Eliminar filtros
                </span>
              </button>
            )}
          </div>
          <div className="mt-16 mb-10">
            {!isLoading ? (
              (buscador || cards).length > 0 && precioDolar ? (
                  <div className="lg:grid hidden lg:grid-cols-4 grid-cols-1 lg:gap-0 gap-2">
                    {(buscador || cards).map((card) => (
                       Number(card.porcentaje_promo) > 0 ||
                        Number(card.cantidad_promo) > 0 
                        ? <CardPromo
                        key={card.idproducto}
                        imageUrl={card.imagen}
                        nombre={card.nombre}
                        price={card.precio_dolar}
                        item={card}
                        dolar={precioDolar}
                        label={false}
                        carrito={carrito}
                        setCarrito={setCarrito}
                        priceOffert={card.precio_oferta}
                        admin={admin}
                        carritoLocale={addToCart}
                      />
                      :
                      <Card
                        key={card.idproducto}
                        imageUrl={card.imagen}
                        nombre={card.nombre}
                        price={card.precio_dolar}
                        item={card}
                        dolar={precioDolar}
                        label={false}
                        carrito={carrito}
                        setCarrito={setCarrito}
                        priceOffert={card.precio_oferta}
                        admin={admin}
                        carritoLocale={addToCart}
                      />
                    ))}
                  </div>
              ) : (
                <div className="lg:flex hidden justify-center font-extrabold items-center mt-32 mb-60">
                  No hay productos
                </div>
              )
            ) : (
              <div className="lg:flex hidden justify-center items-center mt-32 mb-60">
                <svg
                  aria-hidden="true"
                  className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#E40F1B]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            )}
            {!isLoading ? (
              (buscador || cards).length > 0 && precioDolar ? 
                <div className="grid lg:hidden lg:grid-cols-4 grid-cols-1 gap-10 lg:gap-4">
                  {(buscador || cards).map((card) => (
                    Number(card.porcentaje_promo) > 0 ||
                    Number(card.cantidad_promo) > 0 
                    ?

                    <CardPromoMobile
                      key={card.idproducto}
                      imageUrl={card.imagen}
                      nombre={card.nombre}
                      price={card.precio_dolar}
                      item={card}
                      dolar={precioDolar}
                      label={false}
                      carrito={carrito}
                      setCarrito={setCarrito}
                      priceOffert={card.precio_oferta}
                      admin={admin}
                      carritoLocale={addToCart}
                    />
                    :
                    <CardMobile
                      key={card.idproducto}
                      imageUrl={card.imagen}
                      nombre={card.nombre}
                      price={card.precio_dolar}
                      item={card}
                      dolar={precioDolar}
                      label={false}
                      carrito={carrito}
                      setCarrito={setCarrito}
                      priceOffert={card.precio_oferta}
                      admin={admin}
                      carritoLocale={addToCart}
                    />
                  ))}
                </div>
                : (
                <div className="flex lg:hidden justify-center font-extrabold items-center mt-32 mb-60">
                  No hay productos
                </div>
              )
            ) : (
              <div className="flex lg:hidden justify-center items-center mt-32 mb-60">
                <svg
                  aria-hidden="true"
                  className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#E40F1B]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            )}
            <div className="border-t-2"></div>
          </div>
        </div>
        {carrito && <Carrito setIsOpen={setCarrito} isOpen={carrito} />}
      </div>
      <div>
        {!isLoading &&
          (buscador || cards).length > 0 &&
          (buscador || cards).map((prod) => {
            const descripcion = prod.descripcion.replace(/<\/?p>/g, "");
            const itemPriceUSD = prod && (Number(prod.precio_oferta_dolares) > 0 ? prod.precio_oferta_dolares : prod.precio_dolar);
            const precioConIncremento = itemPriceUSD * dolar;
            const descuento = precioConIncremento * 0.20;

            const precioFinal = (precioConIncremento - descuento).toFixed(0);
            return (
              <div itemScope itemType="http://schema.org/Product">
                <meta itemProp="productID" content={prod.idproducto} />
                <meta itemProp="brand" content="Sentate Con Estilo" />
                <meta itemProp="name" content={prod.nombre} />
                <meta itemProp="description" content={descripcion} />
                <meta
                  itemProp="url"
                  content={`https://www.sentateconestilo.com.ar/producto/${prod.slug}`}
                />
                <meta
                  itemProp="image"
                  content={`https://sistema.depcsuite.com/productos/${prod.imagen}`}
                />
                <div
                  itemProp="offers"
                  itemScope
                  itemType="http://schema.org/Offer"
                >
                  <link
                    itemProp="availability"
                    href="http://schema.org/InStock"
                  />
                  <link
                    itemProp="itemCondition"
                    href="http://schema.org/NewCondition"
                  />
                  <meta itemProp="price" content={precioFinal} />
                  <meta itemProp="priceCurrency" content="ARS" />
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}
